import { render, staticRenderFns } from "./RecBanner.vue?vue&type=template&id=b8dd92da&scoped=true&"
import script from "./RecBanner.vue?vue&type=script&lang=js&"
export * from "./RecBanner.vue?vue&type=script&lang=js&"
import style0 from "./RecBanner.vue?vue&type=style&index=0&id=b8dd92da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dd92da",
  null
  
)

export default component.exports